import { useRouter } from 'next/navigation';
import React from 'react';
import { useTranslation } from 'react-i18next';

import errorImageDesktop from '@/assets/images/error-image-desktop.png';
import errorImageMobile from '@/assets/images/error-image-mobile.png';
import {
  ErrorContainer,
  ErrorDetails,
  ErrorHeading,
  ErrorText
} from '@/components/ErrorMessage/styled';
import useDeviceType from '@/hooks/useDeviceType';
import { useChat } from '@/providers/ChatProvider';
import { ButtonFullWidth } from '@/styled/button.styled';
import { useTheme } from '@/styled/themes/ThemeProvider/useTheme';
import { ButtonVariants } from '@/types/styled';

export const ErrorMessage: React.FC = () => {
  const { isMobile } = useDeviceType();
  const { t } = useTranslation();
  const { theme } = useTheme();
  const router = useRouter();
  const { setChatError } = useChat();
  const imgSrc = isMobile ? errorImageMobile.src : errorImageDesktop.src;

  const handleReload = () => {
    setChatError(false);
    router.refresh();
  };

  return (
    <ErrorContainer>
      <img
        width={isMobile ? '152px' : '190px'}
        height={isMobile ? '200px' : '250px'}
        alt="error-image"
        src={imgSrc}
      />
      <ErrorText>
        <ErrorHeading>{t('error.heading')}</ErrorHeading>
        <ErrorDetails>{t('error.details')}</ErrorDetails>
        <ButtonFullWidth
          $variant={ButtonVariants.Filled}
          $color={theme.brand.mainRed}
          onClick={handleReload}
        >
          {t('error.button')}
        </ButtonFullWidth>
      </ErrorText>
    </ErrorContainer>
  );
};
